import devProjects from './development'
import productProjects from './product'

const projects = [
  ...devProjects,
  ...productProjects
]

export default projects;
